export default{
    logged : false,
}